import { inject, Injectable } from '@angular/core';
import { NeedLoginService } from '@df/session/need-login.service';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { LOGIN_FORM_MODAL_ID } from './../../login/form/modal/login-form-modal.component';
@Injectable({
    providedIn: 'root'
})
export class NeedLoginServiceDecorator extends NeedLoginService {
    protected dfModalService = inject(DfModalService);

    private lastVariant: string | undefined;
    /**
     * we dont have /login page, instead we have modal
     */
    override onNeedLoginAction(): void {
        this.dfModalService.open(undefined, LOGIN_FORM_MODAL_ID, this.lastVariant, { variant: 'close' });
    }

    override needLogin(callback: () => any, variant?: string): void {
        this.lastVariant = variant;
        return super.needLogin(callback);
    }
}
